import useCurrentMember from '@/member/hooks/useCurrentMember'
import { useOrgContext } from '@/org/contexts/OrgContext'
import { useContext } from 'react'
import { MeetingContext } from '../contexts/MeetingContext'

// #115: any member of the meeting's circle — a participant of it, as for the
// meeting itself — may share its compte rendu once the meeting is over (the
// server checks it again)
export default function useCanShareMeetingSummary(): boolean {
  const { meeting, isEnded } = useContext(MeetingContext)!
  const { orgData } = useOrgContext()
  const currentMember = useCurrentMember()

  return (
    !!meeting &&
    isEnded &&
    !!currentMember &&
    !!orgData
      ?.getParticipants(meeting.circleId)
      .some(({ member }) => member.id === currentMember.id)
  )
}
